<script setup lang="ts">
import { computed } from 'vue';
import { parseRichText } from '@forma/shared';
// Текст со ссылками вида [текст](https://адрес). Рендерится без v-html, поэтому безопасен.
const props = defineProps<{ text: string; tag?: string }>();
const parts = computed(() => parseRichText(props.text ?? ''));
</script>
<template>
  <component :is="tag || 'span'" class="rich-text"><template v-for="(part, index) in parts" :key="index"><a v-if="part.type === 'link'" :href="part.href" target="_blank" rel="noopener noreferrer" @click.stop>{{ part.text }}</a><template v-else>{{ part.text }}</template></template></component>
</template>
